module.exports = __webpack_public_path__ + "static/media/basarim-sensin-dernegi.af80e617.png";